<script setup lang="ts">
import { ref } from 'vue'
import { useUserStore } from '@/stores/user'
import SwitchInfoModal from '@/components/dashboard/SwitchInfoModal.vue'
import SwitchHistoryModal from '@/components/dashboard/SwitchHistoryModal.vue'

const user = useUserStore()
const infoOpen = ref(false)
const historyOpen = ref(false)
</script>

<template>
  <div
    v-if="user.profile && user.serverSwitchEnabled"
    class="panel flex flex-wrap items-center justify-between gap-3 !py-3 !px-4"
  >
    <div class="flex items-center gap-2">
      <span class="badge badge-outline-primary">⇄</span>
      <span class="text-sm font-bold">Смены сервера</span>
      <button
        type="button"
        class="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-white-dark/50 text-xs font-bold text-white-dark transition hover:border-primary hover:text-primary"
        aria-label="Справка о сменах сервера"
        title="Справка"
        @click="infoOpen = true"
      >
        ?
      </button>
    </div>

    <div class="flex flex-wrap items-center gap-3">
      <span class="text-lg font-extrabold text-primary">
        {{ user.profile.key_switches_remaining }}
      </span>
      <button
        type="button"
        class="btn btn-sm btn-outline-primary"
        @click="historyOpen = true"
      >
        История смен
      </button>
    </div>

    <SwitchInfoModal :open="infoOpen" @close="infoOpen = false" />
    <SwitchHistoryModal :open="historyOpen" @close="historyOpen = false" />
  </div>
</template>
